/**
 * Recognising links that point back into the workspace.
 *
 * Three surfaces need the same answer to "is this URL one of ours, and what
 * does it point at?" — the web client to skip the OG scraper, the mobile
 * client to route a tap into a native screen, and the server to resolve the
 * object behind the card. One parser keeps their answers identical.
 */
/**
 * Web sections → kinds. Notification links use the same plural paths, and
 * `/my-tasks/:id` is the path the tasks page itself produces.
 */
const SECTIONS = {
    chat: 'chat',
    tasks: 'task',
    'my-tasks': 'task',
    projects: 'project',
    spaces: 'space',
    whiteboards: 'whiteboard',
    meetings: 'meeting',
};
/**
 * Reads `/tasks/abc123…` into a typed reference, or null for any path that is
 * not an object detail page. Extra segments (`/meetings/:id/room`) and the
 * query string ride along in `path` untouched.
 */
export function parseInternalPath(path) {
    const [pathname] = path.split('?');
    const [, section, id] = pathname.split('/');
    const kind = section ? SECTIONS[section] : undefined;
    // Ids are Mongo ObjectIds; anything else (`/projects/new`) is a page, not
    // an object.
    if (!kind || !id || !/^[a-f\d]{24}$/i.test(id))
        return null;
    return { kind, id, path };
}
/** The first http(s) link in a message body, or none. */
export function firstLink(body) {
    const match = /\bhttps?:\/\/[^\s<>()]+[^\s<>().,;:!?'"]/i.exec(body);
    return match?.[0];
}
